/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { Environment } from "../../../Config/constants";
import { IListNotificationsPayload, IListNotificationsResponse } from "./notifications.interface";

export class NotificationsApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public list = async ({ page, type, priority, offset }: IListNotificationsPayload): Promise<Result<IListNotificationsResponse>> => {
    try {
        const response = await this.service.get(`/notifications`, { params: { 
          offset: Number(Environment.OFFSET_REGISTERS),
          page,
          type,
          priority,
          
        }});

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public markAsRead = async (notificationId: string): Promise<Result<void>> => {
    try {
        const response = await this.service.patch(`/notifications/${notificationId}/seen`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  // public update = async (data: IUpdateCustomerPayload): Promise<Result<void>> => {
  //   try {
  //       const response = await this.service.put(`/customers/${data.id}`, data );

  //     return Result.ok(response.data);
  //   } catch (error: any) {
  //     return Result.fail(error?.response?.data ?? error);
  //   }
  // };
}
